export const MAIN_SKILLS = [
  {
    color: "#F7DF1E",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 32 32"
      >
        <path
          fill="currentColor"
          d="M2 2v28h28V2zm15.238 21.837c0 2.725-1.6 3.969-3.931 3.969c-2.106 0-3.325-1.087-3.95-2.406l2.144-1.294c.413.731.788 1.35 1.694 1.35c.862 0 1.412-.338 1.412-1.656v-8.944h2.631zm6.224 3.969c-2.444 0-4.025-1.162-4.794-2.688l2.144-1.237c.563.919 1.3 1.6 2.594 1.6c1.087 0 1.788-.544 1.788-1.3c0-.9-.713-1.219-1.919-1.75l-.656-.281c-1.9-.806-3.156-1.825-3.156-3.969c0-1.975 1.506-3.475 3.85-3.475c1.675 0 2.875.581 3.738 2.106l-2.05 1.313c-.45-.806-.938-1.125-1.694-1.125c-.768 0-1.256.488-1.256 1.125c0 .788.488 1.106 1.619 1.6l.656.281c2.238.956 3.494 1.938 3.494 4.137c0 2.363-1.863 3.662-4.357 3.662z"
        />
      </svg>
    ),
    type: "JavaScript",
  },
  {
    color: "#61DAFB",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 24 24"
      >
        <g fill="currentColor" fillRule="evenodd">
          <circle cx="11.996" cy="11.653" r="2.142" />
          <path
            fillRule="nonzero"
            d="M11.996 7.81c2.768 0 5.397.39 7.396 1.078c2.22.764 3.575 1.894 3.575 2.765c0 .927-1.463 2.131-3.838 2.918c-1.89.626-4.42.968-7.133.968c-2.85 0-5.409-.335-7.277-.974c-1.17-.4-2.136-.92-2.799-1.486c-.595-.51-.895-1.016-.895-1.426c0-.874 1.302-1.988 3.475-2.746c2-.697 4.693-1.098 7.496-1.098m0-1.025c-2.912 0-5.718.418-7.834 1.156C1.622 8.825 0 10.213 0 11.653c0 1.486 1.741 2.978 4.387 3.882c1.989.68 4.654 1.029 7.609 1.029c2.816 0 5.451-.356 7.456-1.02c2.75-.912 4.54-2.385 4.54-3.891c0-1.445-1.675-2.842-4.266-3.735c-2.113-.727-4.854-1.134-7.73-1.134m-3.348 2.96c1.383-2.399 3.034-4.481 4.63-5.87c1.77-1.54 3.426-2.15 4.18-1.714c.803.463 1.116 2.331.611 4.782c-.402 1.95-1.37 4.312-2.725 6.663c-1.424 2.469-2.992 4.518-4.48 5.817c-.93.814-1.863 1.391-2.685 1.682c-.738.26-1.327.268-1.682.063c-.757-.436-1.072-2.121-.643-4.381c.395-2.081 1.394-4.615 2.794-7.043m-.888-.512c-1.455 2.522-2.495 5.162-2.913 7.363c-.501 2.643-.11 4.742 1.137 5.46c1.289.744 3.45-.02 5.555-1.86c1.583-1.383 3.217-3.518 4.693-6.077c1.406-2.44 2.415-4.9 2.84-6.969c.585-2.837.203-5.124-1.102-5.876c-1.252-.722-3.298.03-5.366 1.83C10.92 4.568 9.197 6.74 7.76 9.231m.891 4.378C7.264 11.215 6.285 8.744 5.879 6.67c-.451-2.305-.152-4.043.602-4.479c.802-.465 2.577.198 4.448 1.859c1.49 1.322 3.052 3.34 4.411 5.689c1.429 2.467 2.42 4.848 2.804 6.785c.24 1.213.274 2.31.115 3.167c-.143.77-.43 1.284-.785 1.49c-.756.437-2.373-.132-4.117-1.633c-1.605-1.38-3.302-3.511-4.706-5.937m-.887.514c1.459 2.52 3.226 4.74 4.925 6.2c2.039 1.755 4.052 2.463 5.298 1.742c1.287-.745 1.705-2.999 1.162-5.742c-.408-2.061-1.441-4.543-2.922-7.1c-1.41-2.437-3.039-4.54-4.618-5.942C9.443 1.36 7.271.548 5.967 1.303c-1.25.724-1.62 2.873-1.094 5.563c.429 2.193 1.45 4.769 2.891 7.258"
          />
        </g>
      </svg>
    ),
    type: "ReactJs",
  },
  {
    color: "#61DAFB",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 24 24"
      >
        <g fill="currentColor" fillRule="evenodd">
          <circle cx="11.996" cy="11.653" r="2.142" />
          <path
            fillRule="nonzero"
            d="M11.996 7.81c2.768 0 5.397.39 7.396 1.078c2.22.764 3.575 1.894 3.575 2.765c0 .927-1.463 2.131-3.838 2.918c-1.89.626-4.42.968-7.133.968c-2.85 0-5.409-.335-7.277-.974c-1.17-.4-2.136-.92-2.799-1.486c-.595-.51-.895-1.016-.895-1.426c0-.874 1.302-1.988 3.475-2.746c2-.697 4.693-1.098 7.496-1.098m0-1.025c-2.912 0-5.718.418-7.834 1.156C1.622 8.825 0 10.213 0 11.653c0 1.486 1.741 2.978 4.387 3.882c1.989.68 4.654 1.029 7.609 1.029c2.816 0 5.451-.356 7.456-1.02c2.75-.912 4.54-2.385 4.54-3.891c0-1.445-1.675-2.842-4.266-3.735c-2.113-.727-4.854-1.134-7.73-1.134m-3.348 2.96c1.383-2.399 3.034-4.481 4.63-5.87c1.77-1.54 3.426-2.15 4.18-1.714c.803.463 1.116 2.331.611 4.782c-.402 1.95-1.37 4.312-2.725 6.663c-1.424 2.469-2.992 4.518-4.48 5.817c-.93.814-1.863 1.391-2.685 1.682c-.738.26-1.327.268-1.682.063c-.757-.436-1.072-2.121-.643-4.381c.395-2.081 1.394-4.615 2.794-7.043m-.888-.512c-1.455 2.522-2.495 5.162-2.913 7.363c-.501 2.643-.11 4.742 1.137 5.46c1.289.744 3.45-.02 5.555-1.86c1.583-1.383 3.217-3.518 4.693-6.077c1.406-2.44 2.415-4.9 2.84-6.969c.585-2.837.203-5.124-1.102-5.876c-1.252-.722-3.298.03-5.366 1.83C10.92 4.568 9.197 6.74 7.76 9.231m.891 4.378C7.264 11.215 6.285 8.744 5.879 6.67c-.451-2.305-.152-4.043.602-4.479c.802-.465 2.577.198 4.448 1.859c1.49 1.322 3.052 3.34 4.411 5.689c1.429 2.467 2.42 4.848 2.804 6.785c.24 1.213.274 2.31.115 3.167c-.143.77-.43 1.284-.785 1.49c-.756.437-2.373-.132-4.117-1.633c-1.605-1.38-3.302-3.511-4.706-5.937m-.887.514c1.459 2.52 3.226 4.74 4.925 6.2c2.039 1.755 4.052 2.463 5.298 1.742c1.287-.745 1.705-2.999 1.162-5.742c-.408-2.061-1.441-4.543-2.922-7.1c-1.41-2.437-3.039-4.54-4.618-5.942C9.443 1.36 7.271.548 5.967 1.303c-1.25.724-1.62 2.873-1.094 5.563c.429 2.193 1.45 4.769 2.891 7.258"
          />
        </g>
      </svg>
    ),
    type: "React Native",
  },
  {
    color: "#000000",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 128 128"
      >
        <path
          fill="currentColor"
          d="M64 0A64 64 0 0 0 0 64a64 64 0 0 0 64 64a64 64 0 0 0 35.508-10.838L47.014 49.34v40.238H38.4V38.4h10.768l57.125 73.584A64 64 0 0 0 128 64A64 64 0 0 0 64 0m17.777 38.4h8.534v48.776L81.777 75.97Zm24.18 73.92l-.111.096z"
        />
      </svg>
    ),
    type: "NextJs",
  },
  {
    color: "#3178C6",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 24 24"
      >
        <g fill="none">
          <g clipPath="url(#akarIconsTypescriptFill0)">
            <path
              fill="currentColor"
              d="M23.429 0H.57A.571.571 0 0 0 0 .571V23.43a.57.57 0 0 0 .571.571H23.43a.571.571 0 0 0 .571-.571V.57a.571.571 0 0 0-.572-.57m-9.143 12.826h-2.857v8.888H9.143v-8.888H6.286v-1.969h8zm.64 8.38v-2.375s1.298.978 2.855.978s1.497-1.018 1.497-1.158c0-1.477-4.412-1.477-4.412-4.751c0-4.452 6.429-2.695 6.429-2.695l-.08 2.116s-1.078-.719-2.296-.719c-1.218 0-1.657.58-1.657 1.198c0 1.597 4.452 1.438 4.452 4.652c0 4.95-6.788 2.755-6.788 2.755"
            />
          </g>
          <defs>
            <clipPath id="akarIconsTypescriptFill0">
              <path fill="#fff" d="M0 0h24v24H0z" />
            </clipPath>
          </defs>
        </g>
      </svg>
    ),
    type: "TypeScript",
  },
  {
    color: "#DD0031",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="m12 2.5l8.84 3.15l-1.34 11.7L12 21.5l-7.5-4.15l-1.34-11.7zm0 2.1L6.47 17h2.06l1.11-2.78h4.7L15.45 17h2.05zm1.62 7.9h-3.23L12 8.63z"
        />
      </svg>
    ),
    type: "Angular",
  },
  {
    color: "#E44D26",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 16 16"
      >
        <path
          fill="currentColor"
          d="M.946 0L2.23 14.4L7.992 16l5.777-1.602L15.055 0zM12.26 4.71H5.502l.161 1.809H12.1l-.485 5.422l-3.623 1.004l-3.618-1.004l-.247-2.774H5.9l.126 1.41l1.967.53l.004-.001l1.968-.531l.204-2.29H4.048l-.476-5.341h8.847l-.158 1.766z"
        />
      </svg>
    ),
    type: "HTML",
  },
  {
    color: "#264DE4",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.6rem"
        height="1.6rem"
        viewBox="0 0 14 14"
      >
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M.12.175A.5.5 0 0 1 .5 0h13a.5.5 0 0 1 .494.578l-1.5 9.5a.5.5 0 0 1-.207.332l-5 3.5a.5.5 0 0 1-.574 0l-5-3.5a.5.5 0 0 1-.207-.332l-1.5-9.5A.5.5 0 0 1 .12.175M4.2 2.463a.625.625 0 1 0 0 1.25h3.42L4.99 5.357a.625.625 0 0 0 .331 1.155h3.295v1.863L7 9.585L5.135 8.188a.625.625 0 0 0-.75 1l2.24 1.68a.625.625 0 0 0 .75 0l2.24-1.68a.625.625 0 0 0 .25-.5v-2.8a.625.625 0 0 0-.625-.624H7.5l2.63-1.645a.625.625 0 0 0-.33-1.155H4.2Z"
          clipRule="evenodd"
        />
      </svg>
    ),
    type: "CSS",
  },
  {
    color: "#54C5F8",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 24 24"
      >
        <path
          fill="currentColor"
          d="M5.9 15.375L2.5 12l11-11h6.775zM13.5 23l-5.925-5.925L13.5 11.15h6.775l-5.925 5.925L20.275 23z"
        />
      </svg>
    ),
    type: "Flutter",
  },
  {
    color: "#F05032",
    icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="2rem"
        height="2rem"
        viewBox="0 0 640 640"
      >
        <path
          fill="currentColor"
          d="M237.9 461.4C237.9 463.4 235.6 465 232.7 465C229.4 465.3 227.1 463.7 227.1 461.4C227.1 459.4 229.4 457.8 232.3 457.8C235.3 457.5 237.9 459.1 237.9 461.4zM206.8 456.9C206.1 458.9 208.1 461.2 211.1 461.8C213.7 462.8 216.7 461.8 217.3 459.8C217.9 457.8 216 455.5 213 454.6C210.4 453.9 207.5 454.9 206.8 456.9zM251 455.2C248.1 455.9 246.1 457.8 246.4 460.1C246.7 462.1 249.3 463.4 252.3 462.7C255.2 462 257.2 460.1 256.9 458.1C256.6 456.2 253.9 454.9 251 455.2zM316.8 72C178.1 72 72 177.3 72 316C72 426.9 141.8 521.8 241.5 555.2C254.3 557.5 258.8 549.6 258.8 543.1C258.8 536.9 258.5 502.7 258.5 481.7C258.5 481.7 188.5 496.7 173.8 451.9C173.8 451.9 162.4 422.8 146 415.3C146 415.3 123.1 399.6 147.6 399.9C147.6 399.9 172.5 401.9 186.2 425.7C208.1 464.3 244.8 453.2 259.1 446.6C261.4 430.6 267.9 419.5 275.1 412.9C219.2 406.7 162.8 398.6 162.8 302.4C162.8 274.9 170.4 261.1 186.4 243.5C183.8 237 175.3 210.2 189 175.6C209.9 169.1 258 202.6 258 202.6C278 197 299.5 194.1 320.8 194.1C342.1 194.1 363.6 197 383.6 202.6C383.6 202.6 431.7 169 452.6 175.6C466.3 210.3 457.8 237 455.2 243.5C471.2 261.2 481 275 481 302.4C481 398.9 422.1 406.6 366.2 412.9C375.4 420.8 383.2 435.8 383.2 459.3C383.2 493 382.9 534.7 382.9 542.9C382.9 549.4 387.5 557.3 400.2 555C500.2 521.8 568 426.9 568 316C568 177.3 455.5 72 316.8 72zM169.2 416.9C167.9 417.9 168.2 420.2 169.9 422.1C171.5 423.7 173.8 424.4 175.1 423.1C176.4 422.1 176.1 419.8 174.4 417.9C172.8 416.3 170.5 415.6 169.2 416.9zM158.4 408.8C157.7 410.1 158.7 411.7 160.7 412.7C162.3 413.7 164.3 413.4 165 412C165.7 410.7 164.7 409.1 162.7 408.1C160.7 407.5 159.1 407.8 158.4 408.8zM190.8 444.4C189.2 445.7 189.8 448.7 192.1 450.6C194.4 452.9 197.3 453.2 198.6 451.6C199.9 450.3 199.3 447.3 197.3 445.4C195.1 443.1 192.1 442.8 190.8 444.4zM179.4 429.7C177.8 430.7 177.8 433.3 179.4 435.6C181 437.9 183.7 438.9 185 437.9C186.6 436.6 186.6 434 185 431.7C183.6 429.4 181 428.4 179.4 429.7z"
        />
      </svg>
    ),
    type: "Git",
  },
];
